export default __webpack_public_path__ + "9b1747ff1cf57f624b587ad9e2c047fb.svg";